export default function loadLang(lang = 'en-us') {
  return import(`./${lang}.json`);
}
